import React, { Component } from "react";
import classNames from "classnames";

import { EventSortableColumn } from "@formant/core/model/EventSortableColumn";
import { IEventSort } from "@formant/core/model/IEventSort";
import { HStack } from "@formant/ui/component/common/HStack";

import { SortIcon } from "../common/SortIcon";
import * as styles from "./EventSort.scss";

export interface IEventSortProps {
    sort: IEventSort;
    hideDevice: boolean;
    onChangeSort: (sort: IEventSort) => void;
}

export class EventSort extends Component<IEventSortProps> {
    public render() {
        const { onSortByDeviceName, onSortByTime } = this;
        const {
            sort: { column, order },
            hideDevice,
        } = this.props;
        return (
            <HStack
                className={styles["event-sort"]}
                vAlign="center"
                hAlign="end"
            >
                <div className={styles.label}>Sort by:</div>
                {!hideDevice && (
                    <div
                        className={classNames(
                            styles.item,
                            column === "device.name" && styles.active,
                        )}
                        onClick={onSortByDeviceName}
                    >
                        Device{" "}
                        <SortIcon
                            active={column === "device.name"}
                            order={order}
                        />
                    </div>
                )}
                <div
                    className={classNames(
                        styles.item,
                        column === "time" && styles.active,
                    )}
                    onClick={onSortByTime}
                >
                    Time <SortIcon active={column === "time"} order={order} />
                </div>
            </HStack>
        );
    }

    private onSortByDeviceName = () => {
        this.toggleSort("device.name");
    };

    private onSortByTime = () => {
        this.toggleSort("time");
    };

    private toggleSort(column: EventSortableColumn) {
        const {
            sort: { column: currentColumn, order: currentOrder },
            onChangeSort,
        } = this.props;
        onChangeSort({
            column,
            order:
                column === currentColumn && currentOrder === "asc"
                    ? "desc"
                    : "asc",
        });
    }
}
